export default "__VITE_ASSET__yhQT16td__"